import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import jQuery from "jquery";
window.$ = window.jQuery = jQuery;
import "popper.js";
import i18n from "@/i18n/i18n"; // import i18n
import "@/assets/CSS/fonts.css";

createApp(App).use(store).use(router).use(i18n).mount("#app");
